import * as React from "react";
import { Modal, Typography } from "@material-ui/core";
import styled from "styled-components";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { SecondaryButton } from "Components/Shared/Buttons/SecondaryButton";

type Props = {
  open: boolean;
  successBtnText?: string;
  closeBtnText: string;
  title?: string;
  onClose: () => void;
  onSuccess: () => void;
};

export const StyledModal = styled(Modal)`
  display: grid;
  justify-content: center;
  align-items: center;

  & > div {
    &:first-of-type {
      background-color: rgba(255, 255, 255, 0.8) !important;
    }
  }
`;

const StyledBody = styled.div`
  outline: none;
  background-color: #fff;
  border: 1px solid ${props => props.theme.colors.border};
  box-shadow: ${props => props.theme.shadow.primary};
  padding: ${props => props.theme.spacing(3, 4, 5)};
`;

const StyledTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 300;
  text-transform: uppercase;
  margin-bottom: ${props => props.theme.spacing(2)}px;
`;

const StyledBtnsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * {
    &:first-of-type {
      margin-right: ${props => props.theme.spacing(3)}px;
    }
  }
`;

export const PrimaryModal: React.FunctionComponent<Props> = props => {
  const {
    open,
    successBtnText,
    closeBtnText,
    title,
    onClose,
    onSuccess,
    children,
  } = props;

  return (
    <StyledModal open={open} onClose={onClose}>
      <StyledBody>
        {title && <StyledTitle>{title}</StyledTitle>}

        {children}

        <StyledBtnsWrapper>
          {successBtnText && (
            <PrimaryButton onClick={onSuccess}>{successBtnText}</PrimaryButton>
          )}
          <SecondaryButton onClick={onClose}>{closeBtnText}</SecondaryButton>
        </StyledBtnsWrapper>
      </StyledBody>
    </StyledModal>
  );
};
